import Alert from 'react-bootstrap/Alert'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const AlertaDatosContribuyente = (error) => {
  const [mensajeError, setMensajeError] = useState('')
  const [tituloError, setTituloError] = useState('')

  useEffect(() => {
    switch (error.error.error) {
      case 'planPagos':
        setTituloError('Ya existe un plan de pagos')
        setMensajeError(
          'No es posible continuar con la declaración jurada porque ya tiene un plan de pago vigente. ' +
            'Si tiene alguna duda comuníquese con el area correspondiente.'
        )
        break
      case 'original':
        setTituloError('ERROR INTERNO')
        setMensajeError('El legajo no tiene cargada una original para el año. ')
        break
      case 'API':
        setTituloError('Error al procesar los datos')
        setMensajeError(error.error.mensaje)
        break
      case 'INTERNO':
        setTituloError('ERROR INTERNO')
        setMensajeError('Comuniquese con el area correspondiente.')
        break
      default:
        setTituloError('Error al procesar los datos')
        setMensajeError(
          'Ocurrió un error al intentar obtener los datos para efectuar la operación, por favor intente más tarde.'
        )
    }
  }, [error.error])

  return (
    <Alert variant={'primary'} style={{ textAlign: 'center' }}>
      <Alert.Heading>{tituloError}</Alert.Heading>
      {mensajeError}
    </Alert>
  )
}

AlertaDatosContribuyente.propTypes = {
  error: PropTypes.any
}

export default AlertaDatosContribuyente
